import React from 'react'

import { Button, Card, Heading, Link } from 'core'
import { Grid, GridItem } from 'layout'
import {
  isRegistered,
  linkTo,
  waitlistState
} from 'event-taxonomy'
import { formatDate, formatDateRange, formatWebinarDate } from 'helpers'

import css from './style.scss'

// Session sales advertise a run window; a course is a webinar with a start date.
const runDates = event => {
  const { target } = event

  if (event.type !== 'session_sale') return formatWebinarDate(target.start_at)
  if (!target.advertised_start_date) return null

  return target.advertised_end_date
    ? formatDateRange(target.advertised_start_date, target.advertised_end_date)
    : formatDate(target.advertised_start_date)
}

const statusFor = event => {
  if (isRegistered(event)) return { text: '* Registered', tone: css.statusRegistered }
  if (event.type !== 'session_sale') return null

  const closesAt = event.target.open_registration_end_at
  if (!closesAt) return null

  switch (waitlistState(event.target)) {
    case 'waitlist':
      return { text: `Waitlist closes ${formatDate(closesAt)}`, tone: css.statusWaitlist, soldOut: true }
    case 'sold_out':
      return { text: 'Sold out', tone: css.statusSoldOut }
    // A null seat count means the API didn't compute one — say nothing about
    // availability, just the deadline.
    default:
      return { text: `Registration closes ${formatDate(closesAt)}`, tone: css.statusOpen }
  }
}

/**
 * Paid offerings get a heavier treatment than the live-event rows so the two
 * sections read as genuinely separate.
 */
const ProgramCard = ({ event }) => {
  const dates = runDates(event)
  const status = statusFor(event)

  return (
    <div className={css.programCard}>
      <Card>
        <Grid>
          <GridItem col='4/6' tablet1of1 mobile1of1>
            <Heading size='h4' weight='semibold'>{event.target.title}</Heading>
            {dates && <p className={css.programDates}>{dates}</p>}
          </GridItem>

          <GridItem col='2/6' tablet1of1 mobile1of1>
            {status && (
              <p className={status.tone}>
                {status.soldOut && <span className={css.soldOutBadge}>Sold Out</span>}
                {status.text}
              </p>
            )}
            {/* target is ignored for internal react-router links (see
                EventListItem.js), so it's always safe to pass — needed here
                so external/Zoom events open in a new tab, not in-SPA. */}
            <Link to={linkTo(event)} target='_blank'>
              <Button size='secondary' noMargin>View Details</Button>
            </Link>
          </GridItem>
        </Grid>
      </Card>
    </div>
  )
}

ProgramCard.propTypes = {
  event: React.PropTypes.shape({
    type: React.PropTypes.oneOf(['webinar', 'session_sale']).isRequired,
    target: React.PropTypes.object.isRequired
  }).isRequired
}

export default ProgramCard
